import { Component, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  ButtonComponent as OldButtonComponent,
  confirmPasswordValidator,
  FormGridComponent as oldFormGridComponent,
  TextInputComponent,
} from 'component-library';
import { ActivatedRoute } from '@angular/router';
import { ButtonComponent, FormGridComponent, InputComponent } from 'design-system';
import {getThemeConfig, ilionxValidators} from 'shared';
import { HeroComponent, HeroVariant, TopBarComponent } from 'design-system-rijks';
import { AuthenticationConfig } from 'shared';
import { AuthenticationService } from '../../config/authentication-service';

@Component({
  selector: 'tngh-set-password-page',
  templateUrl: './set-password-page.component.html',
  styleUrls: [
    '../login/login.component.scss',
    '../../../../component-library/src/lib/authentication/otp-form/otp-form.component.scss',
  ],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonComponent,
    FormGridComponent,
    TextInputComponent,
    FormGridComponent,
    oldFormGridComponent,
    OldButtonComponent,
    InputComponent,
    ButtonComponent,
    HeroComponent,
    TopBarComponent,
  ],
})
export class SetPasswordPageComponent {
  formGroup: FormGroup;
  resetCode: string | undefined;
  theme: AuthenticationConfig['theme'];

  // theming variables
  logoVariant!: HeroVariant;
  logoUrl = '';
  logoAltText = '';

  constructor(
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private config: AuthenticationConfig,
    fb: FormBuilder,
  ) {
    this.theme = config.theme;

    this.route.queryParams.subscribe((params) => {
      this.resetCode = params['resetCode'];
    });

    this.formGroup = fb.group(
      {
        newPassword: [undefined, [Validators.required, ilionxValidators.password(config.passwordValidationOptions)]],
        confirmPassword: [undefined, [Validators.required, ilionxValidators.password(config.passwordValidationOptions)]],
      },
      { validators: confirmPasswordValidator },
    );
  }

  public useRijksVersion = computed(() => {
    const cfg = getThemeConfig(this.theme);
    if (cfg.logoVariant) this.logoVariant = cfg.logoVariant;
    this.logoUrl = cfg.logoUrl ?? '';
    this.logoAltText = cfg.logoAltText ?? '';
    return cfg.isRijksTheme;
  });

  onSubmit() {
    if (this.formGroup.valid && this.resetCode) {
      const resetPassword = {
        resetCode: this.resetCode,
        confirmPassword: this.formGroup.value.confirmPassword,
        newPassword: this.formGroup.value.newPassword,
      };
      this.authenticationService.setPassword(resetPassword).subscribe();
    }
  }
}
